
export const CART_DISABLE_REASON = {
    NO_TABS: 'no_tabs',
    IOS_15_1: 'ios_15_1',
}